import axios from "axios";

const ReportService = () => {
  return Object.freeze({
    getFeedbackReport: async (
      _url,
      responseType = "blob", // Default response type is blob
      forceToReceiveInBlobFormat = true
    ) => {
      const response = await axios(_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        responseType: forceToReceiveInBlobFormat && responseType, //Force to receive data in a Blob Format
      });

      return response;
    },
  });
};

export default ReportService;
